import React from 'react';
import { Route } from 'react-router-dom';
import PageHeaderLayout from '../layouts/PageHeaderLayout/PageHeaderLayout';
import withAuthentication from '@alphapoint/apex-web/lib/hocs/withAuthentication';

import DashboardPage from './DashboardPage';
import MarketDataPage from './MarketDataPage';
import BuySellPage from './BuySellPage';
// import ConvertPage from '@alphapoint/apex-web/lib/layouts/ConvertLayout/ConvertLayout';
import ProductDetailsPage from './ProductDetailsPage';
import SettingsPage from './SettingsPage';

import WalletsLayout from '@alphapoint/apex-web/lib/layouts/WalletsLayout/WalletsLayoutContainer';
import AssetActivityDetailsLayout from '@alphapoint/apex-web/lib/layouts/AssetActivityDetailsLayout/AssetActivityDetailsLayout';

import DigitalAssetsPage from '@alphapoint/apex-web/lib/components/DigitalAssets/DigitalAssetsPageContainer';
import DigitalAssetsOfferingProfilePage from '@alphapoint/apex-web/lib/components/DigitalAssets/DigitalAssetsOfferingProfilePageContainer';
import forVerified from '@alphapoint/apex-web/lib/hocs/forVerified';
import IBALayout from '@alphapoint/apex-web/lib/components/IBA/IbaLayout';

import StreamingPage from './StreamingPage';
import { TradingPage } from './Exchange/TradingPage';

const WalletsComponent = () => <WalletsLayout detailsLink="/activity" />;

const routesConfig = [
  { path: '/dashboard', component: DashboardPage, exact: true },
  { path: '/dashboard/market-data', component: MarketDataPage },
  { path: '/wallets', component: WalletsComponent },
  { path: '/exchange/:symbol?', component: TradingPage },
  { path: '/buy-sell', component: BuySellPage },
  // { path: '/convert', component: ConvertPage },
  { path: '/iba', component: IBALayout },
  { path: '/activity', component: ProductDetailsPage },
  { path: '/settings', component: SettingsPage },
  { path: '/asset-activity-details', component: AssetActivityDetailsLayout },
  { path: '/eotc', component: StreamingPage },
  { path: '/token-offerings', component: DigitalAssetsPage, exact: true },
  { path: '/token-offerings/:id', component: DigitalAssetsOfferingProfilePage },
];

const InteriorPage = () => {
  return (
    <React.Fragment>
      <PageHeaderLayout />
      {routesConfig.map((route, index) => {
        return <Route key={index} exact={route.exact} path={route.path} component={route.component} />;
      })}
    </React.Fragment>
  );
};

export default withAuthentication(forVerified(InteriorPage));
